"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.9958 14.6146H36.3312V10.4167C36.3301 8.89754 35.7262 7.44094 34.652 6.36675C33.5778 5.29257 32.1212 4.6886 30.6021 4.6875H10.4167C8.89771 4.68915 7.44143 5.29329 6.36736 6.36736C5.29329 7.44143 4.68915 8.89771 4.6875 10.4167V29.6563C4.68915 31.1752 5.29329 32.6315 6.36736 33.7056C7.44143 34.7796 8.89771 35.3838 10.4167 35.3854H13.6687V39.1542C13.6929 40.8071 14.3709 42.3831 15.5544 43.5373C16.7378 44.6914 18.3303 45.3298 19.9833 45.3125H38.9958C40.6492 45.3303 42.2422 44.6922 43.4261 43.538C44.61 42.3838 45.2883 40.8074 45.3125 39.1542V20.7729C45.2883 19.1196 44.61 17.5433 43.4261 16.3891C42.2422 15.2348 40.6492 14.5968 38.9958 14.6146ZM7.8125 29.6563V10.4167C7.81305 9.72617 8.0876 9.06411 8.57585 8.57585C9.06411 8.0876 9.72617 7.81305 10.4167 7.8125H30.6021C31.2926 7.81305 31.9546 8.0876 32.4429 8.57585C32.9312 9.06411 33.2057 9.72617 33.2062 10.4167V29.6563C33.2057 30.3468 32.9312 31.0088 32.4429 31.4971C31.9546 31.9853 31.2926 32.2599 30.6021 32.2604H10.4167C9.72617 32.2599 9.06411 31.9853 8.57585 31.4971C8.0876 31.0088 7.81305 30.3468 7.8125 29.6563ZM42.1875 39.1542C42.1635 39.9786 41.8145 40.7602 41.2166 41.3284C40.6187 41.8966 39.8205 42.2054 38.9958 42.1875H19.9833C19.1591 42.2049 18.3613 41.8958 17.7639 41.3277C17.1664 40.7595 16.8177 39.9783 16.7937 39.1542V35.3854H30.6021C32.1212 35.3843 33.5778 34.7804 34.652 33.7062C35.7262 32.632 36.3301 31.1754 36.3312 29.6563V17.7396H38.9958C39.8205 17.7216 40.6187 18.0304 41.2166 18.5987C41.8145 19.1669 42.1635 19.9484 42.1875 20.7729V39.1542Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.3208 20.0375C28.3208 19.6231 28.1562 19.2257 27.8632 18.9327C27.5701 18.6397 27.1727 18.475 26.7583 18.475H14.2583C13.8439 18.475 13.4465 18.6397 13.1534 18.9327C12.8604 19.2257 12.6958 19.6231 12.6958 20.0375C12.6958 20.4519 12.8604 20.8494 13.1534 21.1424C13.4465 21.4354 13.8439 21.6 14.2583 21.6H26.7583C27.1727 21.6 27.5701 21.4354 27.8632 21.1424C28.1562 20.8494 28.3208 20.4519 28.3208 20.0375Z",
    fill: fill
  }));
};

exports["default"] = _default;